import React, {useState} from "react";
import {FormattedMessage} from "react-intl";
import {withAuth} from "../../hoc/Auth";
import TableRow from "./TableRow";
import Loader from "../Utils/Loader";
import Empty from "./Empty";
import classes from "./styles.module.css";

function ContractsTable({token, data, projects}) {
    const [loading] = useState(false);

    return loading ? (
        <Loader/>
    ) : (
        <table className={classes.Table}>
            <thead>
            <tr>
                <th><FormattedMessage id="ContractsTable.table.name" defaultMessage="Название"/></th>
                <th><FormattedMessage id="ContractsTable.table.date" defaultMessage="Дата"/></th>
                <th><FormattedMessage id="ContractsTable.table.project" defaultMessage="Проект"/></th>
                <th><FormattedMessage id="ContractsTable.table.psaCount" defaultMessage="Кол-во ПСА"/></th>
                <th><FormattedMessage id="ContractsTable.table.psaProcessing" defaultMessage="ПСА в обработке"/></th>
                <th/>
            </tr>
            </thead>
            <tbody>
            {!loading && data && data.length > 0 ? (
                data.map((el, i) => {
                    const project = projects && projects.find((p) => p && p.uuid === el.merchantId);
                    return <TableRow key={i} data={el} project={project}/>;
                })
            ) : (
                <Empty/>
            )}
            </tbody>
        </table>
    );
}

export default withAuth(ContractsTable);



// WEBPACK FOOTER //
// ./src/Components/ContractsTable/index.js